import { motion } from "framer-motion";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../components/Footer";

export default function Activities({ showFooter = true, isPage = true }) {
  const navigate = useNavigate();
  const { type } = useParams();

  const [activitiesData, setActivitiesData] = useState([]);
  const [loading, setLoading] = useState(true);

  const API = process.env.PARCEL_API_URL;

  useEffect(() => {
    if (!API) return;

    axios
      .get(`${API}/api/activities`)
      .then((res) => setActivitiesData(res.data))
      .catch((err) => console.log("ERROR:", err))
      .finally(() => setLoading(false));
  }, [API]);

  const categories = [
    { name: "Charity", path: "charity", desc: "Helping the needy with love and care." },
    { name: "Youth Programs", path: "youth", desc: "Empowering youth through programs and leadership." },
    { name: "Events", path: "events", desc: "Organizing events that bring the community together." },
  ];

  const wrapperClass = `bg-orange-50 flex flex-col ${
    isPage ? "min-h-screen" : ""
  }`;

  // 🔥 Skeleton Card
  const SkeletonCard = () => (
    <div className="bg-white p-5 rounded-xl shadow-md animate-pulse">
      <div className="w-full h-40 bg-gray-200 rounded mb-3"></div>
      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
      <div className="h-3 bg-gray-200 rounded w-full"></div>
    </div>
  );

  // 🔥 CATEGORY PAGE
  if (type) {
    const selected = categories.find((a) => a.path === type);

    const filtered = activitiesData.filter(
      (item) => item.category === type
    );

    return (
      <div className={wrapperClass}>
        <div className="px-6 md:px-24 py-16 flex-grow">

          {/* 🔙 BACK BUTTON ONLY IF FULL PAGE */}
          {isPage && (
            <button
              onClick={() => navigate("/")}
              className="mb-6 text-orange-500 font-semibold hover:underline"
            >
              ← Back to Home
            </button>
          )}

          <h1 className="text-3xl font-bold text-orange-500 mb-6">
            {selected?.name} Activities
          </h1>

          <p className="text-gray-600 max-w-2xl mb-10">
            {selected?.desc}
          </p>

          <div className="grid md:grid-cols-3 gap-6">
            {loading ? (
              Array(6).fill(0).map((_, i) => <SkeletonCard key={i} />)
            ) : filtered.length > 0 ? (
              filtered.map((item, index) => (
                <motion.div
                  key={item._id}
                  initial={{ opacity: 0, x: -60 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.15 }}
                  whileHover={{ scale: 1.05, y: -6 }}
                  onClick={() => navigate(`/activities/view/${item._id}`)}
                  className="bg-white p-5 rounded-xl shadow-md cursor-pointer hover:shadow-xl transition"
                >
                  {item.image && (
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-40 object-cover rounded mb-3"
                    />
                  )}

                  <h3 className="font-bold text-orange-500 mb-2">
                    {item.name}
                  </h3>

                  <p className="text-sm text-gray-600 line-clamp-2">
                    {item.desc}
                  </p>
                </motion.div>
              ))
            ) : (
              <p>No activities added yet</p>
            )}
          </div>
        </div>

        {showFooter && isPage && <Footer />}
      </div>
    );
  }

  // 🔥 CATEGORY LIST (MAIN PAGE + HOME PREVIEW)
  return (
    <div className={wrapperClass}>
      <section className="px-6 md:px-24 py-16 flex-grow">

        {/* 🔙 BACK BUTTON ONLY IF FULL PAGE */}
        {isPage && (
          <button
            onClick={() => navigate("/")}
            className="mb-6 text-orange-500 font-semibold hover:underline"
          >
            ← Back to Home
          </button>
        )}

        <h2 className="text-3xl font-bold text-center mb-10">
          Our <span className="text-orange-500">Activities</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          {loading ? (
            Array(3).fill(0).map((_, i) => <SkeletonCard key={i} />)
          ) : (
            categories.map((cat, i) => {
              const latest = activitiesData.find(
                (item) => item.category === cat.path
              );

              return (
                <motion.div
                  key={i}
                  onClick={() => navigate(`/activities/${cat.path}`)}
                  initial={{ opacity: 0, x: -60 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.4, delay: i * 0.2 }}
                  whileHover={{ scale: 1.05, y: -8 }}
                  className="bg-white rounded-xl shadow-md cursor-pointer hover:shadow-xl transition overflow-hidden"
                >
                  {latest?.image && (
                    <img
                      src={latest.image}
                      alt={cat.name}
                      className="w-full h-40 object-cover"
                    />
                  )}

                  <div className="p-5 text-center">
                    <h3 className="font-bold text-orange-500 mb-2">
                      {cat.name}
                    </h3>
                  </div>
                </motion.div>
              );
            })
          )}
        </div>

      </section>

      {showFooter && isPage && <Footer />}
    </div>
  );
}